export enum RuleBuilderPage {
    Rule = "Rule",
    Data = "Data",
    Test = "Test",
    Configuration = "Config",
}
